/**
 * Notification themes configuration
 * Matches the 7 gradient themes from Figma designs
 */

import { NotificationTheme } from "../types";

/**
 * Predefined notification themes
 * These match the notification_themes table seeded in the database
 */
export const NOTIFICATION_THEMES: NotificationTheme[] = [
  {
    id: "purple-orange",
    name: "Paars-Oranje",
    gradient_start: "#8b5cf6",
    gradient_middle: "#a78bfa",
    gradient_end: "#fdba74",
    gradient_direction: "to-b",
    corner_color_1: "#fcd34d",
    corner_color_2: "#6ee7b7",
    sort_order: 1,
    created_at: "",
  },
  {
    id: "orange-purple",
    name: "Oranje-Paars",
    gradient_start: "#fdbf6c",
    gradient_middle: "#a78bfa",
    gradient_end: "#5e20ef",
    gradient_direction: "to-b",
    corner_color_1: "#fcd34d",
    corner_color_2: "#6ee7b7",
    sort_order: 2,
    created_at: "",
  },
  {
    id: "cream-orange",
    name: "Crème-Oranje",
    gradient_start: "#f5f1ec",
    gradient_middle: "#fa9427",
    gradient_end: "#efcd20",
    gradient_direction: "to-b",
    corner_color_1: "#fcd34d",
    corner_color_2: "#6ee7b7",
    sort_order: 3,
    created_at: "",
  },
  {
    id: "green",
    name: "Groen",
    gradient_start: "#99ff51",
    gradient_middle: "#81ffcc",
    gradient_end: "#20ef99",
    gradient_direction: "to-b",
    corner_color_1: "#fcd34d",
    corner_color_2: "#6ee7b7",
    sort_order: 4,
    created_at: "",
  },
  {
    id: "blue",
    name: "Blauw",
    gradient_start: "#8fdaff",
    gradient_middle: "#81a9ff",
    gradient_end: "#206fef",
    gradient_direction: "to-b",
    corner_color_1: "#fcd34d",
    corner_color_2: "#6ee7b7",
    sort_order: 5,
    created_at: "",
  },
  {
    id: "pink-purple",
    name: "Roze-Paars",
    gradient_start: "#ff8fda",
    gradient_middle: "#a78bfa",
    gradient_end: "#6f20ef",
    gradient_direction: "to-b",
    corner_color_1: "#fcd34d",
    corner_color_2: "#6ee7b7",
    sort_order: 6,
    created_at: "",
  },
  {
    id: "yellow-green",
    name: "Geel-Groen",
    gradient_start: "#fef08a",
    gradient_middle: "#bbf7d0",
    gradient_end: "#34d399",
    gradient_direction: "to-b",
    corner_color_1: "#fcd34d",
    corner_color_2: "#6ee7b7",
    sort_order: 7,
    created_at: "",
  },
  // New themes
  {
    id: "sunset",
    name: "Zonsondergang",
    gradient_start: "#f97316",
    gradient_middle: "#ec4899",
    gradient_end: "#8b5cf6",
    gradient_direction: "to-b",
    corner_color_1: "#fbbf24",
    corner_color_2: "#f472b6",
    sort_order: 8,
    created_at: "",
  },
  {
    id: "ocean",
    name: "Oceaan",
    gradient_start: "#22d3ee",
    gradient_middle: "#3b82f6",
    gradient_end: "#1e3a8a",
    gradient_direction: "to-b",
    corner_color_1: "#67e8f9",
    corner_color_2: "#60a5fa",
    sort_order: 9,
    created_at: "",
  },
  {
    id: "forest",
    name: "Bos",
    gradient_start: "#4ade80",
    gradient_middle: "#16a34a",
    gradient_end: "#14532d",
    gradient_direction: "to-b",
    corner_color_1: "#86efac",
    corner_color_2: "#22c55e",
    sort_order: 10,
    created_at: "",
  },
  {
    id: "rose",
    name: "Roos",
    gradient_start: "#fda4af",
    gradient_middle: "#f43f5e",
    gradient_end: "#9f1239",
    gradient_direction: "to-b",
    corner_color_1: "#fecdd3",
    corner_color_2: "#fb7185",
    sort_order: 11,
    created_at: "",
  },
  {
    id: "gold",
    name: "Goud",
    gradient_start: "#fde047",
    gradient_middle: "#f59e0b",
    gradient_end: "#b45309",
    gradient_direction: "to-b",
    corner_color_1: "#fef08a",
    corner_color_2: "#fbbf24",
    sort_order: 12,
    created_at: "",
  },
  {
    id: "midnight",
    name: "Middernacht",
    gradient_start: "#a78bfa",
    gradient_middle: "#6366f1",
    gradient_end: "#1e1b4b",
    gradient_direction: "to-b",
    corner_color_1: "#c4b5fd",
    corner_color_2: "#818cf8",
    sort_order: 13,
    created_at: "",
  },
];

/**
 * Get theme by ID
 */
export const getThemeById = (id: string | null | undefined): NotificationTheme => {
  if (!id) return NOTIFICATION_THEMES[0];
  return NOTIFICATION_THEMES.find(t => t.id === id) || NOTIFICATION_THEMES[0];
};

/**
 * Default theme IDs for notification types
 */
export const DEFAULT_THEME_BY_TYPE: Record<string, string> = {
  // Familie admin notification types
  score: "purple-orange",
  score_positive: "purple-orange",
  score_negative: "orange-purple",
  event: "blue",
  birthday: "pink-purple",
  challenge: "green",
  custom: "purple-orange",
  // Super admin notification types
  role_assignment: "blue",
  new_weekend: "green",
  new_feature: "purple-orange",
  system_announcement: "cream-orange",
};


